import { render, staticRenderFns } from "./ProfileAvatarButton.vue?vue&type=template&id=03deaae4&scoped=true&"
import script from "./ProfileAvatarButton.vue?vue&type=script&lang=js&"
export * from "./ProfileAvatarButton.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAvatarButton.vue?vue&type=style&index=0&id=03deaae4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03deaae4",
  null
  
)

export default component.exports